import {Injectable} from '@angular/core';
import {GatewayValues} from '@models/adminstration/gateway/gateway-configuration/gateway-values';
import {GatewayRegex} from '@models/adminstration/gateway/gateway-configuration/gateway-regex';

@Injectable({
  providedIn: 'root'
})
export class GatewayRegexService {

  constructor() { }

  private removeSpecialChars = /[^a-zA-Z0-9]/g;
  private findLeadingNumber = /^[0-9].+$/;
  private findLongNames = /[a-zA-Z0-9_]{300}/;

  fillMaskFromOPCVar(mask: string, variable: GatewayValues): string{
    let tmpString = mask;

    // Fill the string Regexp
    const replaceName = /{name}/g;
    const replaceDescription = /{description}/g;
    const replaceDimension = /{dimension}/g;
    const replaceDatatype = /{datatype}/g;

    tmpString = tmpString.replace(replaceName, variable.name);
    tmpString = tmpString.replace(replaceDescription, variable.description);
    tmpString = tmpString.replace(replaceDimension, String(variable.dimension));
    tmpString = tmpString.replace(replaceDatatype, String(variable.datatype));
    return tmpString;
  }

  updateStringWithRegex(stringToUpdate: string, regexList: GatewayRegex[]): string{
    let tmpString = stringToUpdate;

    if(!regexList){
      regexList = [];
    }

    //Users Regex
    for(const regex of regexList){
      if(regex.replacement === undefined || regex.replacement === null){
        regex.replacement = '';
      }
      try {
        tmpString = tmpString.replace(new RegExp(regex.regexp || '', regex.flags || ''), regex.replacement || '');
      } catch (err) {
        console.warn('GatewayRegexService. Exception in creating regex', err);
      }
    }

    //Default case with default regex
    tmpString = tmpString.replace(this.removeSpecialChars, '_');
    if(this.findLongNames.test(tmpString)) {
      tmpString = tmpString.substring(tmpString.length - 127);
    }
    if(this.findLeadingNumber.test(tmpString)) {
      tmpString = '_' + tmpString;
    }

    return tmpString;

  }
}
